import { connect } from "react-redux";
import { matchPath, withRouter } from "react-router-dom";
import CollapsableQuotationPriceDetailsMobile from "app/pages/Booking/Quotation/PriceDetails/CollapsableQuotationPriceDetailsMobile";
import PriceDetails from "app/pages/Booking/Quotation/PriceDetails/PriceDetails";
import {
	calculatePreBookTotal,
	getQuoteTotalWithDelta,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import {
	calculatePartialPaymentAmount,
	checkIfPaymentCasino4xDisponible,
	getEcheancierCasino,
} from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = (state, ownProps) => {
	const booking = state.booking;
	const offerType = booking.offer.type;
	const currentPathname = ownProps.location.pathname;

	const isPagePayment = matchPath(currentPathname, {
		path: "/booking/payment",
	});

	const isSDPPagePayment = matchPath(currentPathname, {
		path: "/sdp/booking/payment",
	});

	const isSDPPageQuote = matchPath(currentPathname, {
		path: "/sdp/booking/quote",
	});

	const mensualite = getEcheancierCasino(state);

	const partialPaymentData = calculatePartialPaymentAmount(state);

	const included =
		isSDPPagePayment || isSDPPageQuote
			? state.ficheProduit.included
			: state.ficheProduit.included && state.ficheProduit.included[offerType];

	const notIncluded =
		isSDPPagePayment || isSDPPageQuote
			? state.ficheProduit.notIncluded
			: state.ficheProduit.notIncluded && state.ficheProduit.notIncluded[offerType];

	return {
		brand: state.brand.code,
		shop: state.shop,
		total:
			isPagePayment || isSDPPagePayment
				? getQuoteTotalWithDelta(state)
				: calculatePreBookTotal(state),
		mensualite: mensualite.apport,
		coutCredit: mensualite.coutCredit,
		partialPayment: partialPaymentData,
		hasChildren: booking.children > 0,
		isPayment4xDisponible: checkIfPaymentCasino4xDisponible(state),
		included,
		notIncluded,
		isPagePayment: isPagePayment || isSDPPagePayment,
		paymentType: booking.paymentType,
		paymentMode: booking.paymentMode,
		usableCouponsStatus: state.usableCoupons.status,
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
	};
};

export const CollapsableQuotationPriceDetailContainerMobile = withRouter(
	connect(mapStateToProps)(CollapsableQuotationPriceDetailsMobile)
);

export const QuotationPriceDetailContainer = withRouter(connect(mapStateToProps)(PriceDetails));
